/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import * as MsDyn365 from '@msdyn365-commerce/core';
import { ICusTermsOfServiceViewProps } from './cus-terms-of-service';

export default (props: ICusTermsOfServiceViewProps) => {
    return (
        <>
            <header id='header' className='header'></header>
            <div id='content' className='content'>
                {props.selectedTerms && (
                    <MsDyn365.RichTextComponent
                        text={props.selectedTerms.content}
                        className={`${props.selectedTerms?.country} ${props.selectedTerms?.language}`}
                    />
                )}
            </div>
            <footer id='footer' className='footer'></footer>
        </>
    );
};
